import { ContactDBInstance } from './contact_dbl';
import { api } from '@/api/api';
import { apis } from '@/config';
import ContactUtilInterface from './contact_util';
import { ContactServerInstance } from './contact_server';
import { ContactEdmHelperInstance } from './contact_edm_help';
import { ContactCollegeHelperInstance } from './contact_college_help';
import { contactHealthDetectHelper } from './contact_healthdetect_helper';
import { enableSync as enableSyncFn, enableEdmSync as enableEdmSyncFn } from './contact_sync_types';
import { ContactSyncCore } from './contact_sync_core';
import { ContactSyncCustomer } from './contact_sync_customer';
import { ContactSyncScheduler } from './contact_sync_scheduler';
import { ContactEventHub } from './util/event_hub';
import { EnterpriseSyncCoordinator } from './contact_sync_enterprise_coordinator';
import { ContactSyncStatusTracker } from './contact_sync_status_tracker';
import { ensureContactDataReady } from './contact_sync_ensure_ready';
import { savePersonalSyncStatus } from './contact_sync_personal_status';
import { setStoreContactSyncPageInfo, setStoreLastTime } from './util/sync';
export class ContactSync {
    constructor() {
        this.systemApi = api.getSystemApi();
        this.eventApi = api.getEventApi();
        this.http = api.getDataTransApi();
        this.storeApi = api.getDataStoreApi();
        this.dbApi = api.getNewDBApi();
        this.contactDB = ContactDBInstance;
        this.contactUtil = ContactUtilInterface;
        this.contactServer = ContactServerInstance;
        this.contactEdmHelper = ContactEdmHelperInstance;
        this.contactCollegeHelper = ContactCollegeHelperInstance;
        this.dataTracker = api.requireLogicalApi(apis.dataTrackerApiImp);
        this.loggerApi = api.requireLogicalApi(apis.loggerApiImpl);
        this.mailApi = api.requireLogicalApi(apis.mailApiImpl);
        this.accountApi = api.requireLogicalApi(apis.accountApiImpl);
        this.productApi = api.requireLogicalApi(apis.productAuthApiImpl);
        this.performanceApi = api.requireLogicalApi(apis.performanceImpl);
        this.isSyncColleague = false;
        this.localContactReady = false;
        this.contactHealthDetectHelper = contactHealthDetectHelper;
        this.enableNonMainTabHttpSync = false;
        const lokiApi = api.requireLogicalApi(apis.dbMemoryApiImpl);
        const eventHub = new ContactEventHub(this.eventApi);
        this.tracker = new ContactSyncStatusTracker();
        this.contactDB.setTracker(this.tracker);
        this.ctx = {
            eventHub,
            systemApi: this.systemApi,
            eventApi: this.eventApi,
            http: this.http,
            storeApi: this.storeApi,
            dbApi: this.dbApi,
            lokiApi,
            contactDB: this.contactDB,
            contactUtil: this.contactUtil,
            contactServer: this.contactServer,
            contactEdmHelper: this.contactEdmHelper,
            contactCollegeHelper: this.contactCollegeHelper,
            dataTracker: this.dataTracker,
            loggerApi: this.loggerApi,
            mailApi: this.mailApi,
            accountApi: this.accountApi,
            productApi: this.productApi,
            performanceApi: this.performanceApi,
            contactHealthDetectHelper: this.contactHealthDetectHelper,
            tracker: this.tracker,
        };
        this.coordinator = new EnterpriseSyncCoordinator({
            systemApi: this.systemApi,
            http: this.http,
            storeApi: this.storeApi,
            dbApi: this.dbApi,
            lokiApi,
            contactUtil: this.contactUtil,
            contactServer: this.contactServer.enterpriseModule,
            contactDB: this.contactDB.enterpriseModule,
            tracker: this.tracker,
        }, (newInterval) => {
            this.contactUtil.setContactSyncIntervalSeq(newInterval);
        }, (_account) => {
            var _a;
            const isMainAccount = _account === ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id);
            this.coreSync.doSyncAction({ force: false, isMainAccount, _account, skipPersonalSync: true }).catch(ex => {
                console.error('[contact_sync] onSyncTrigger doSyncAction failed', ex);
            });
        });
        this.coreSync = new ContactSyncCore(this.ctx, this.coordinator);
        this.customerSync = new ContactSyncCustomer(this.ctx);
        this.schedulerSync = new ContactSyncScheduler(this.ctx, this.coreSync, this.customerSync);
    }
    get isSyncCustomer() {
        return this.customerSync.isSyncCustomer;
    }
    get eventHub() {
        return this.ctx.eventHub;
    }
    get switchCustomerEdmSync() {
        return this.customerSync.switchCustomerEdmSync;
    }
    get contactCustomerSyncHandle() {
        return this.customerSync.contactCustomerSyncHandle;
    }
    getContactReady() {
        return this.localContactReady;
    }
    setContactReady(isReady) {
        this.localContactReady = isReady;
    }
    enableSync() {
        return enableSyncFn(this.ctx);
    }
    enableEdmSync() {
        return enableEdmSyncFn(this.ctx);
    }
    setContactSync(options) {
        this.schedulerSync.setContactSync(options);
    }
    setCustomerContactSync() {
        this.customerSync.setCustomerContactSync();
    }
    async syncContactCustomer(params) {
        return this.customerSync.syncContactCustomer(params);
    }
    async syncCustomerListLoop(force) {
        return this.customerSync.syncCustomerListLoop(force);
    }
    async syncClueListLoop() {
        return this.customerSync.syncClueListLoop();
    }
    async customerContactInit(tid) {
        return this.customerSync.customerContactInit(tid);
    }
    async getTableInited(table) {
        const count = await this.dbApi.getTableCount(table);
        return count > 0;
    }
    clearSyncAll() {
        this.schedulerSync.clearSyncAll();
    }
    destroyCoordinator(_account) {
        this.coordinator.destroy(_account);
    }
    destroyAllCoordinators() {
        this.coordinator.destroyAll();
    }
    getEnterpriseConfig(_account) {
        var _a;
        const account = _account || ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        if (!account) {
            return null;
        }
        return this.coordinator.getConfig(account);
    }
    async resetPersonalSyncState() {
        var _a, _b;
        const _account = ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        const domain = ((_b = this.systemApi.getCurrentUser(_account)) === null || _b === void 0 ? void 0 : _b.domain) || '';
        try {
            await savePersonalSyncStatus(this.storeApi, { status: 'never', lastDexieWriteTime: 0 }, _account);
        }
        catch (e) {
            console.error('[ContactSync] resetPersonalSyncState: savePersonalSyncStatus failed', e);
        }
        const taskApi = api.requireLogicalApi(apis.taskApiImpl);
        const syncContext = {
            store: this.storeApi,
            taskApi,
            systemApi: this.systemApi,
            accountApi: this.accountApi,
        };
        try {
            await setStoreContactSyncPageInfo({ from: 'personal', domain, _account, lastUpdateTime: 0, source: 'lingxi' }, true, syncContext);
        }
        catch (e) {
            console.error('[ContactSync] resetPersonalSyncState: setStoreContactSyncPageInfo personal failed', e);
        }
        try {
            await setStoreContactSyncPageInfo({ from: 'personalOrg', domain, _account, lastUpdateTime: 0, source: 'lingxi' }, true, syncContext);
        }
        catch (e) {
            console.error('[ContactSync] resetPersonalSyncState: setStoreContactSyncPageInfo personalOrg failed', e);
        }
        try {
            await setStoreLastTime('personal', 0, syncContext);
        }
        catch (e) {
            console.error('[ContactSync] resetPersonalSyncState: setStoreLastTime personal failed', e);
        }
        try {
            await setStoreLastTime('personalOrg', 0, syncContext);
        }
        catch (e) {
            console.error('[ContactSync] resetPersonalSyncState: setStoreLastTime personalOrg failed', e);
        }
    }
    clearEnterpriseConfigStores() {
        var _a;
        const _account = ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        try {
            this.coordinator.clearConfigStores(_account);
        }
        catch (e) {
            console.error('[ContactSync] clearEnterpriseConfigStores failed', e);
        }
    }
    async ensureDataReady(options) {
        await ensureContactDataReady(this.ctx, this.coreSync, this.coordinator, Object.assign(Object.assign({}, options), { allowHttpSync: this.enableNonMainTabHttpSync }));
    }
}
export const ContactSyncInstance = new ContactSync();
